import { render, staticRenderFns } from "./document-header.vue?vue&type=template&id=055ffcce&scoped=true&"
import script from "./document-header.vue?vue&type=script&lang=js&"
export * from "./document-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055ffcce",
  null
  
)

export default component.exports